import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 setBox" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_8 = { disabled: true }
const _hoisted_9 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_10 = { class: "formcontainer flex flex-col" }
const _hoisted_11 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_12 = { class: "w-6/12" }
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "w-6/12 leftspacing" }
const _hoisted_15 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_16 = { class: "w-6/12" }
const _hoisted_17 = { class: "text-sm" }
const _hoisted_18 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_19 = { class: "w-6/12" }
const _hoisted_20 = { class: "text-sm" }
const _hoisted_21 = { class: "w-6/12 leftspacing" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_24 = { class: "w-6/12" }
const _hoisted_25 = { class: "text-sm" }
const _hoisted_26 = { class: "w-6/12 leftspacing" }
const _hoisted_27 = { class: "text-sm" }
const _hoisted_28 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_29 = { class: "w-full" }
const _hoisted_30 = { class: "text-sm" }
const _hoisted_31 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_32 = { class: "w-6/12" }
const _hoisted_33 = { class: "text-sm" }
const _hoisted_34 = { class: "w-6/12 leftspacing" }
const _hoisted_35 = { class: "text-sm" }
const _hoisted_36 = { class: "flex w-full" }
const _hoisted_37 = { class: "w-6/12 upperspacing" }
const _hoisted_38 = { class: "text-sm" }
const _hoisted_39 = { class: "w-6/12 upperspacing leftspacing" }
const _hoisted_40 = { class: "text-sm" }
const _hoisted_41 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_42 = { class: "w-6/12" }
const _hoisted_43 = { class: "text-sm" }
const _hoisted_44 = { class: "w-6/12 leftspacing" }
const _hoisted_45 = { class: "text-sm" }
const _hoisted_46 = { class: "w-full upperspacing" }
const _hoisted_47 = { class: "text-sm" }
const _hoisted_48 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_49 = { disabled: true }
const _hoisted_50 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_51 = { class: "formcontainer flex flex-col" }
const _hoisted_52 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_53 = { class: "w-full" }
const _hoisted_54 = { class: "text-sm" }
const _hoisted_55 = { class: "leftspacing w-full" }
const _hoisted_56 = { class: "text-sm" }
const _hoisted_57 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_58 = { class: "w-6/12" }
const _hoisted_59 = { class: "text-sm" }
const _hoisted_60 = { class: "w-6/12 leftspacing" }
const _hoisted_61 = { class: "text-sm" }
const _hoisted_62 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_63 = { class: "w-6/12" }
const _hoisted_64 = { class: "text-sm" }
const _hoisted_65 = { class: "w-6/12 leftspacing" }
const _hoisted_66 = { class: "text-sm" }
const _hoisted_67 = { class: "row flex flex-row w-full pt-2" }
const _hoisted_68 = { class: "w-6/12" }
const _hoisted_69 = { class: "text-sm" }
const _hoisted_70 = { class: "w-6/12 leftspacing" }
const _hoisted_71 = { class: "text-sm" }
const _hoisted_72 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_73 = { class: "w-6/12" }
const _hoisted_74 = { class: "text-sm" }
const _hoisted_75 = { class: "w-6/12 leftspacing" }
const _hoisted_76 = { class: "text-sm" }
const _hoisted_77 = { class: "upperspacing w-full" }
const _hoisted_78 = { class: "text-sm" }
const _hoisted_79 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_80 = { class: "w-full" }
const _hoisted_81 = { class: "text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "title" }, "Vendors", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "file",
          class: "hidden",
          accept: ".xls,.xlsx",
          ref: "file",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fileReader($event)))
        }, null, 544),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton'])
            }, [
              (_ctx.tableRow.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                : (_openBlock(), _createElementBlock("img", _hoisted_5)),
              _cache[5] || (_cache[5] = _createTextVNode(" Filters "))
            ], 2)
          ])
        ])
      ])
    ]),
    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "mt-3 text-xs" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ", -1)),
    _createElementVNode("div", null, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.tableRow,
        headersData: _ctx.headers,
        openPopup: true,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.selectedIndex == 20003 && _ctx.popUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          class: "thirdPartyPopup",
          popUp: _ctx.popUp
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _cache[8] || (_cache[8] = _createElementVNode("h1", null, "Vendor", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCancelbtn('close')))
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "controllabel" }, "Display Name", -1)),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.thirdParty.displayName  != undefined ? _ctx.thirdParty.displayName : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "controllabel mr-2 mb-2" }, "Status", -1)),
                          _createVNode(_component_ToggleSwitch, {
                            modelValue: _ctx.thirdParty.isActive,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.thirdParty.isActive) = $event)),
                            checked: _ctx.thirdParty.isActive
                          }, null, 8, ["modelValue", "checked"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "controllabel" }, "Legal Name", -1)),
                          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.thirdParty.name != undefined ? _ctx.thirdParty.name : 'N/A'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "controllabel" }, "Contact Person", -1)),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.thirdParty.fullName ? _ctx.thirdParty.fullName : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "controllabel" }, "Email", -1)),
                          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.thirdParty.emailAddress ? _ctx.thirdParty.emailAddress : 'N/A'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "controllabel" }, "Phone Number", -1)),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.thirdParty.phoneNumber ? _ctx.thirdParty.phoneNumber : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "controllabel" }, "Website", -1)),
                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.thirdParty.website ? _ctx.thirdParty.website : 'N/A'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "controllabel" }, "Address", -1)),
                          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.thirdParty.addressLineOne ? _ctx.thirdParty.addressLineOne : 'N/A'), 1)
                        ])
                      ]),
                      _cache[24] || (_cache[24] = _createElementVNode("h1", { class: "mt-5" }, "Relationship Information", -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "border-b mt-1 border-solid border-lightgrey" }, null, -1)),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[17] || (_cache[17] = _createElementVNode("label", { class: "controllabel" }, "Owner", -1)),
                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.optionsUserArray.find(user => user.value === _ctx.thirdParty.owner)?.label || "N/A"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "controllabel" }, "Signing Location", -1)),
                          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.entitiesList.find(entity => entity.value === _ctx.thirdParty.responsibleBusinessEntity)?.label || "N/A"), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "controllabel" }, "Relationship Type", -1)),
                          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.relationShipType.find(item => item.id == _ctx.thirdParty.relationshipType)?.value || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _cache[20] || (_cache[20] = _createElementVNode("label", { class: "controllabel" }, "Contract Type", -1)),
                          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.contractTypeData.find(item => item.id == _ctx.thirdParty.contractType)?.label|| 'N/A'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _cache[21] || (_cache[21] = _createElementVNode("label", { class: "controllabel" }, "Contract Start Date", -1)),
                          _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.thirdParty.contractStartDate ? _ctx.thirdParty.contractStartDate : 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", { class: "controllabel" }, "Contract Expiry Date", -1)),
                          _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.thirdParty.contractExpirationDate ? _ctx.thirdParty.contractExpirationDate : 'N/A'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _cache[23] || (_cache[23] = _createElementVNode("label", { class: "controllabel" }, "Serving To", -1)),
                        _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.thirdParty.entitiesusethirdparty?.map(item => item.label).join(', ') || 'N/A'), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.selectedIndex == 20004 && _ctx.popUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          class: "thirdPartyContactsPopup",
          popUp: _ctx.popUp
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_48, [
              _cache[27] || (_cache[27] = _createElementVNode("h1", null, "Third-party Contacts", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCancelbtn('close')))
              }, _cache[26] || (_cache[26] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", _hoisted_49, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _cache[28] || (_cache[28] = _createElementVNode("label", { class: "controllabel" }, "Third Party", -1)),
                          _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.thirdPartyContacts.thirdParty.label || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _cache[29] || (_cache[29] = _createElementVNode("label", { class: "controllabel" }, "Type", -1)),
                          _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.type.find(item => item.id === _ctx.thirdPartyContacts.type)?.value || "-"), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _cache[30] || (_cache[30] = _createElementVNode("label", { class: "controllabel" }, "Name", -1)),
                          _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.thirdPartyContacts.fullName || "N/A"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _cache[31] || (_cache[31] = _createElementVNode("label", { class: "controllabel" }, "Job Title", -1)),
                          _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.thirdPartyContacts.role), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _cache[32] || (_cache[32] = _createElementVNode("label", { class: "controllabel" }, "Email", -1)),
                          _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.thirdPartyContacts.emailAddress), 1)
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", { class: "controllabel" }, "Phone", -1)),
                          _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.thirdPartyContacts.phoneNumber), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _cache[34] || (_cache[34] = _createElementVNode("label", { class: "controllabel" }, "Country", -1)),
                          _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.thirdPartyContacts.country), 1)
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _cache[35] || (_cache[35] = _createElementVNode("label", { class: "controllabel" }, "State", -1)),
                          _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.thirdPartyContacts.state), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _cache[36] || (_cache[36] = _createElementVNode("label", { class: "controllabel" }, "City", -1)),
                          _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.thirdPartyContacts.city), 1)
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _cache[37] || (_cache[37] = _createElementVNode("label", { class: "controllabel" }, "PIN Code", -1)),
                          _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.thirdPartyContacts.zipCode), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _cache[38] || (_cache[38] = _createElementVNode("label", { class: "controllabel" }, "Address Line 1", -1)),
                        _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.thirdPartyContacts.addressLineOne), 1)
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _cache[39] || (_cache[39] = _createElementVNode("label", { class: "controllabel" }, "Address Line 2", -1)),
                          _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.thirdPartyContacts.addressLineTwo || "N/A"), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}